import React from "react";
import "./menu.scss";
import 'rsuite/dist/rsuite.min.css';
import {Sidenav,Nav} from 'rsuite';
import { useTranslation } from "react-i18next";

const Menu = () => {
  const { t } = useTranslation();
  const configuration = <><i className="fa fa-laptop" />{t("LT_configuration")}</>
  const dashboard = <><i className="fa fa-bar-chart" />{t("LT_dashboards")}</>
  const reports = <><i className="fa fa-file-word-o" />{t("LT_reports")}</>
  return (
    <Sidenav className="cv-sidenav" appearance = 'subtle'>
      <Sidenav.Body>
        <Nav>
          <Nav.Item eventKey="1" href="#dashboard"><i className="fa fa-home" />{t("LT_home")}</Nav.Item>
          <Nav.Item eventKey="2"><i className="fa fa-users" />{t("LT_users")}</Nav.Item>
          <Nav.Menu eventKey="3" title={configuration}>
            <Nav.Menu eventKey="3-1" title={t("LT_user_s_input")}>
              <Nav.Item eventKey="3-1-1">{t("LT_ideal_cycle_time")}</Nav.Item>
              <Nav.Item eventKey="3-1-2">{t("LT_downtime_reasons")}</Nav.Item>
              <Nav.Item eventKey="3-1-3">{t("LT_defects")}</Nav.Item>
            </Nav.Menu>
            <Nav.Menu eventKey="3-2" title={t("LT_device_interface_options")}>
              <Nav.Item eventKey="3-2-1">{t("LT_data_as_file_output")}</Nav.Item>
              <Nav.Item eventKey="3-2-2">{t("LT_data_recorded_in_m_c_db")}</Nav.Item>
              <Nav.Item eventKey="3-2-3">{t("LT_data_is_from_live_streaming")}</Nav.Item>
            </Nav.Menu>
            <Nav.Item eventKey="3-3">{t("LT_definition_of_shift_timings")}</Nav.Item>
            <Nav.Item eventKey="3-4">{t("LT_customization_for_graphs")}</Nav.Item>
            <Nav.Item eventKey="3-5">{t("LT_thresholds_for_parameters")}</Nav.Item>
          </Nav.Menu>       
          <Nav.Menu eventKey="4" title={dashboard}>
              <Nav.Item eventKey="4-1" href="#dashboard">{t("LT_company")}</Nav.Item>
              <Nav.Item eventKey="4-2" href="#factoryOverview">{t("LT_factory")}</Nav.Item>
              <Nav.Menu eventKey="4-3" title={t("LT_line_dashboard")}>
                <Nav.Item eventKey="4-3-1" href="#lineOverview">{t("LT_line")}</Nav.Item>
                <Nav.Item eventKey="4-3-2" href="#printer">{t("LT_printer")}</Nav.Item>
                <Nav.Item eventKey="4-3-3" href="#inspection">{t("LT_spi")}</Nav.Item>
                <Nav.Item eventKey="4-4-1" href="#PickAndPlace">{t("LT_pick_place")}</Nav.Item>
                <Nav.Item eventKey="4-5-2" href="#pre-aoi">{t("LT_pre_aoi")}</Nav.Item>
                <Nav.Item eventKey="4-6-3" href="#post-aoi">{t("LT_post_aoi")}</Nav.Item>
              </Nav.Menu>
            </Nav.Menu>
            <Nav.Menu eventKey="5" title={reports}>
              <Nav.Item eventKey="5-1">{t("LT_downtime")}</Nav.Item>
              <Nav.Item eventKey="5-2" href="#target-actual">{t("LT_target_v_s_actual_output")}</Nav.Item>
              <Nav.Item eventKey="5-3" href="#inspectionDPM">{t("LT_inspection_dpm")}</Nav.Item>
              <Nav.Item eventKey="5-4" href="#defect-details">{t("LT_defect_details")}</Nav.Item>
              <Nav.Item eventKey="5-5">{t("LT_pick_place_spoilage")}</Nav.Item>
              <Nav.Item eventKey="5-6">{t("LT_latest_error_for_pn_p")}</Nav.Item>
              <Nav.Item eventKey="5-7" href="#pcb-traceability">{t("LT_pcb_traceability")}</Nav.Item>
            </Nav.Menu>
        </Nav>
      </Sidenav.Body>
    </Sidenav>
  );
}

export default Menu;